import { render, staticRenderFns } from "./BookingsSummary.vue?vue&type=template&id=6fb8b5e8&scoped=true"
import script from "./BookingsSummary.vue?vue&type=script&lang=js"
export * from "./BookingsSummary.vue?vue&type=script&lang=js"
import style0 from "./BookingsSummary.vue?vue&type=style&index=0&id=6fb8b5e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb8b5e8",
  null
  
)

export default component.exports